/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ມື້ວານ",
        "-2": "ມື້ກ່ອນ",
        "0": "ມື້ນີ້",
        "1": "ມື້ອື່ນ",
        "2": "ມື້ຮື",
        "future": {
          "other": "ໃນອີກ {0} ມື້"
        },
        "past": {
          "other": "{0} ມື້ກ່ອນ"
        }
      },
      "day-narrow": {
        "-1": "ມື້ວານ",
        "-2": "ມື້ກ່ອນ",
        "0": "ມື້ນີ້",
        "1": "ມື້ອື່ນ",
        "2": "ມື້ຮື",
        "future": {
          "other": "ໃນອີກ {0} ມື້"
        },
        "past": {
          "other": "{0} ມື້ກ່ອນ"
        }
      },
      "day-short": {
        "-1": "ມື້ວານ",
        "-2": "ມື້ກ່ອນ",
        "0": "ມື້ນີ້",
        "1": "ມື້ອື່ນ",
        "2": "ມື້ຮື",
        "future": {
          "other": "ໃນອີກ {0} ມື້"
        },
        "past": {
          "other": "{0} ມື້ກ່ອນ"
        }
      },
      "hour": {
        "0": "ຊົ່ວໂມງນີ້",
        "future": {
          "other": "ໃນອີກ {0} ຊົ່ວໂມງ"
        },
        "past": {
          "other": "{0} ຊົ່ວໂມງກ່ອນ"
        }
      },
      "hour-narrow": {
        "0": "ຊົ່ວໂມງນີ້",
        "future": {
          "other": "ໃນອີກ {0} ຊມ."
        },
        "past": {
          "other": "{0} ຊມ. ກ່ອນ"
        }
      },
      "hour-short": {
        "0": "ຊົ່ວໂມງນີ້",
        "future": {
          "other": "ໃນອີກ {0} ຊມ."
        },
        "past": {
          "other": "{0} ຊມ. ກ່ອນ"
        }
      },
      "minute": {
        "0": "ນາທີນີ້",
        "future": {
          "other": "ໃນອີກ {0} ນາທີ"
        },
        "past": {
          "other": "{0} ນາທີກ່ອນ"
        }
      },
      "minute-narrow": {
        "0": "ນາທີນີ້",
        "future": {
          "other": "ໃນ {0} ນທ."
        },
        "past": {
          "other": "{0} ນທ. ກ່ອນ"
        }
      },
      "minute-short": {
        "0": "ນາທີນີ້",
        "future": {
          "other": "ໃນ {0} ນທ."
        },
        "past": {
          "other": "{0} ນທ. ກ່ອນ"
        }
      },
      "month": {
        "-1": "ເດືອນແລ້ວ",
        "0": "ເດືອນນີ້",
        "1": "ເດືອນໜ້າ",
        "future": {
          "other": "ໃນອີກ {0} ເດືອນ"
        },
        "past": {
          "other": "{0} ເດືອນກ່ອນ"
        }
      },
      "month-narrow": {
        "-1": "ເດືອນແລ້ວ",
        "0": "ເດືອນນີ້",
        "1": "ເດືອນໜ້າ",
        "future": {
          "other": "ໃນອີກ {0} ດ."
        },
        "past": {
          "other": "{0} ດ. ກ່ອນ"
        }
      },
      "month-short": {
        "-1": "ເດືອນແລ້ວ",
        "0": "ເດືອນນີ້",
        "1": "ເດືອນໜ້າ",
        "future": {
          "other": "ໃນອີກ {0} ດ."
        },
        "past": {
          "other": "{0} ດ. ກ່ອນ"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "ໄຕຣມາດກ່ອນໜ້າ",
        "0": "ໄຕຣມາດນີ້",
        "1": "ໄຕຣມາດໜ້າ",
        "future": {
          "other": "ໃນອີກ {0} ໄຕຣມາດ"
        },
        "past": {
          "other": "{0} ໄຕຣມາດກ່ອນ"
        }
      },
      "quarter-narrow": {
        "-1": "ໄຕຣມາດກ່ອນໜ້າ",
        "0": "ໄຕຣມາດນີ້",
        "1": "ໄຕຣມາດໜ້າ",
        "future": {
          "other": "ໃນ {0} ຕມ."
        },
        "past": {
          "other": "{0} ຕມ. ກ່ອນ"
        }
      },
      "quarter-short": {
        "-1": "ໄຕຣມາດກ່ອນໜ້າ",
        "0": "ໄຕຣມາດນີ້",
        "1": "ໄຕຣມາດໜ້າ",
        "future": {
          "other": "ໃນ {0} ຕມ."
        },
        "past": {
          "other": "{0} ຕມ. ກ່ອນ"
        }
      },
      "second": {
        "0": "ຕອນນີ້",
        "future": {
          "other": "ໃນອີກ {0} ວິນາທີ"
        },
        "past": {
          "other": "{0} ວິນາທີກ່ອນ"
        }
      },
      "second-narrow": {
        "0": "ຕອນນີ້",
        "future": {
          "other": "ໃນ {0} ວິ."
        },
        "past": {
          "other": "{0} ວິ. ກ່ອນ"
        }
      },
      "second-short": {
        "0": "ຕອນນີ້",
        "future": {
          "other": "ໃນ {0} ວິ."
        },
        "past": {
          "other": "{0} ວິ. ກ່ອນ"
        }
      },
      "week": {
        "-1": "ອາທິດແລ້ວ",
        "0": "ອາທິດນີ້",
        "1": "ອາທິດໜ້າ",
        "future": {
          "other": "ໃນອີກ {0} ອາທິດ"
        },
        "past": {
          "other": "{0} ອາທິດກ່ອນ"
        }
      },
      "week-narrow": {
        "-1": "ອາທິດແລ້ວ",
        "0": "ອາທິດນີ້",
        "1": "ອາທິດໜ້າ",
        "future": {
          "other": "ໃນອີກ {0} ອທ."
        },
        "past": {
          "other": "{0} ອທ. ກ່ອນ"
        }
      },
      "week-short": {
        "-1": "ອາທິດແລ້ວ",
        "0": "ອາທິດນີ້",
        "1": "ອາທິດໜ້າ",
        "future": {
          "other": "ໃນອີກ {0} ອທ."
        },
        "past": {
          "other": "{0} ອທ. ກ່ອນ"
        }
      },
      "year": {
        "-1": "ປີກາຍ",
        "0": "ປີນີ້",
        "1": "ປີໜ້າ",
        "future": {
          "other": "ໃນອີກ {0} ປີ"
        },
        "past": {
          "other": "{0} ປີກ່ອນ"
        }
      },
      "year-narrow": {
        "-1": "ປີກາຍ",
        "0": "ປີນີ້",
        "1": "ປີໜ້າ",
        "future": {
          "other": "ໃນອີກ {0} ປີ"
        },
        "past": {
          "other": "{0} ປີກ່ອນ"
        }
      },
      "year-short": {
        "-1": "ປີກາຍ",
        "0": "ປີນີ້",
        "1": "ປີໜ້າ",
        "future": {
          "other": "ໃນອີກ {0} ປີ"
        },
        "past": {
          "other": "{0} ປີກ່ອນ"
        }
      }
    },
    "locale": "lo"
  });
}